module.exports = __webpack_public_path__ + "static/media/steering-wheel.2d65261f.svg";